import emojis from './emoji.json';

export const checkIsSelected = (icon1, icon2) => {
  if (!icon1 || !icon2) return false;
  if (icon1.type !== icon2.type) return false;

  switch (icon1.type) {
    case 'emoji':
      return icon1.character === icon2.character;
    case 'appIcon':
      return icon1.app === icon2.app;
    case 'favicon':
      return icon1.type === icon2.type;
    default:
      return false;
  }
};

export const computeAria = (iconData) => {
  if (iconData?.character) {
    // translate from emoji character variable to unicodeName, parsing the version prefix
    const obj = emojis.find((e) => e.character === iconData.character);
    const space = obj.unicodeName.indexOf(' ');
    const label = obj.unicodeName.slice(space).trim();
    return label;
  }
  return iconData ? iconData?.app : null;
};
